import * as React from "react";
import useProductName from "brand-customization/useProductName";
import { formHasErrors } from "util/FormsUtils";
import { Col, Form, ButtonToolbar, Button, Alert, Input } from "components/bootstrap";
import { FormikFormGroup, ExternalLink } from "components/common";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
const OidcGroupSyncForm = ({
  values,
  isSubmitting,
  handleSubmit,
  validateForm,
  submitAllError,
  goToPrevious
}) => {
  const productName = useProductName();
  const sendTelemetry = useSendTelemetry("oidc-groupsync-step");
  const onSubmitAll = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.AUTHENTICATION.OIDC_GROUP_SYNC_SAVE_CLICKED, {
      app_action_value: "save-service"
    });
    if (values.synchronizeGroups) {
      return validateForm().then((errors) => {
        if (!formHasErrors(errors)) {
          handleSubmit();
        }
      });
    }
    return handleSubmit();
  };
  const disableForm = !values.synchronizeGroups;
  return /* @__PURE__ */ React.createElement(Col, { md: 7 }, /* @__PURE__ */ React.createElement(Form, { className: "form form-horizontal" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info", title: "Introduction" }, "This step enables importing OIDC groups as ", productName, " teams. The groups are retrieved via", " ", /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://openid.net/specs/openid-connect-core-1_0.html#UserInfo" }, "the OIDC userinfo endpoint"), ". The group synchronization can be activated by clicking on the checkbox with the label", " ", /* @__PURE__ */ React.createElement("i", null, "Enable Group Synchronization"), ". All groups for a user will be synchronized."), /* @__PURE__ */ React.createElement(
    Input,
    {
      label: "Enable Group Synchronization",
      id: "synchronize-groups-checkbox",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        label: "Synchronize Groups",
        wrapperClassName: "col-sm-12",
        name: "synchronizeGroups",
        help: "Select this option if you want to import OIDC groups as teams",
        type: "checkbox"
      }
    )
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      label: "Groups Claim",
      type: "text",
      help: "Add an OIDC claim name used to sync groups. If you leave it empty 'graylog_teams' will be used as default value.",
      labelClassName: "col-sm-3",
      name: "groupsClaim",
      disabled: disableForm,
      wrapperClassName: "col-sm-9"
    }
  )), submitAllError, /* @__PURE__ */ React.createElement(ButtonToolbar, { className: "pull-right" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: "primary",
      disabled: isSubmitting,
      onClick: () => {
        sendTelemetry(TELEMETRY_EVENT_TYPE.AUTHENTICATION.OIDC_PREVIOUS_SERVER_CONFIG_CLICKED, {
          app_action_value: "server-configuration-button"
        });
        goToPrevious();
      },
      type: "button"
    },
    "Previous: Server Configuration"
  ), /* @__PURE__ */ React.createElement(Button, { disabled: isSubmitting, onClick: onSubmitAll }, "Finish & Save Service"))));
};
export default OidcGroupSyncForm;
